import { widget } from '../../widgets/widget-decorator';
import { BindingEngine, customElement, PLATFORM } from 'aurelia-framework';
import { WidgetBase } from '../widget-base';
import { CustomerService } from '../../services/customer-service';
import { CustomerTotalValuesReportViewModel } from '../../clients/reporting-clients';
import { IApplicationFilter } from '../../interfaces/i-application-filter';
import { useView } from 'aurelia-templating';
import { PortfolioReportCache } from '../../services/portfolio-report-cache';
import { property } from '../property-decorator';


@customElement('nav-widget')
@useView(PLATFORM.moduleName('./nav-widget.html'))
@widget({ name: 'NAV', canUseInReport: true, canUseInDashboard: true, defaultWidth: 27, defaultHeight: 12 })
export class NavWidget extends WidgetBase {
  constructor(element: Element, customerService: CustomerService, private portfolioReportCache: PortfolioReportCache, bindingEngine: BindingEngine) {
    super(element, bindingEngine, customerService);
    this.title = 'Net Asset Value:';
    this.titleFontSize = 14;
  }

  totals: CustomerTotalValuesReportViewModel;

  @property('Value')
  font?: string;

  @property('Value')
  fontSize?: number = 24;

  @property('Value')
  color?: string;

  override async loadData(filter: IApplicationFilter) {
    return this.portfolioReportCache.customerTotals(filter.customer.companyId, filter.dates.toStr, filter.dates.toStr, undefined, false, 0);
  }

  override async setData(data: CustomerTotalValuesReportViewModel[]) {
    this.totals = data[data.length - 1];
  }
}
